import { defineMessages } from 'react-intl';

export default defineMessages({
    exitLink: {
        id: 'amig.links.Exit',
        defaultMessage: 'Exit'
    }
});